module.exports = __webpack_public_path__ + "media/images/vp/icon.deletebutton.red-8af2e00f92470c89350c2bbe7f5fd8e2.svg";